angular.module(NgAppName).component('crPopup', {
	templateUrl: 'crPopup.html',
	transclude: true,
	bindings: {
		isMobile: '<',
		popupName: '@',
		isFs: '<',
		isNotfsMobile: '@',
		isBounceBack: '<',
		noFocusOnClose: '<', // to prevent focus on close button in some situations
		displayMessageOnClose: '<',
		autoOpen: '<',
		moveToBody: '<',
		closeButtonPosition: '@',
		loadContentOnInit: '@',
		cancelButton: '@',
		class: '@',
		bodyId: '@'
	},
	controller: ['$timeout', 'PubSub', '$element', '$cookies', function($timeout, PubSub, $element, $cookies) {
		var ctrl = this;
		this.isOpened = false;
		this.isSuccessMessage = false;

		this.htmlElement = angular.element(document.querySelector('html'));
		this.body = angular.element(document.querySelector('body'));

		this.body.append($element);

		this.callbacks = {};

		this.$onInit = () => {
			// Add GLOBAL event listener (jquery and mootools)
			this.callbacks[this.popupName] = (e) => {
				this.openPopup(e);
			};

			document.addEventListener(`crPopupOpen-${this.popupName}`, this.callbacks[this.popupName]);

			if (ctrl.isMobile) {
				jQuery(window).on('resize', (ev) =>  {
					ev.preventDefault();

					this.resize();
				});

				let mobileShowEntryPopup = false;
				let mobileTriggerOffset = null;
				if (this.bodyId === 'mia' || this.bodyId === 'bov' || this.bodyId === 'brv' || this.bodyId === 'bfp') {
					mobileTriggerOffset = 500;
				}

				let mobileShowEntryPopup2 = false;
				let mobileTriggerOffset2 = null;

				jQuery(window).on('scroll', (ev) =>  {
					if ((this.bodyId === 'mia' || this.bodyId === 'bov' || this.bodyId === 'brv' || this.bodyId === 'bfp') && !!mobileTriggerOffset && mobileShowEntryPopup == false && window.scrollY > mobileTriggerOffset) {
						PubSub.publish('cr-popup-open-popup-in-entry');
						mobileShowEntryPopup = true;
					}

					if (!!this.mobileSaleSearchResultsShowPopupInEntry && this.mobileSaleSearchResultsEntryPopupTriggerPoint) {
						mobileTriggerOffset2 = this.mobileSaleSearchResultsEntryPopupTriggerPoint.getBoundingClientRect().top + window.scrollY;
						if (!!mobileTriggerOffset2 && mobileShowEntryPopup2 == false && window.scrollY > mobileTriggerOffset2) {
							PubSub.publish('cr-popup-open-popup-in-entry');
							mobileShowEntryPopup2 = true;
						}
					}
				});
			}

			let cookieBounceBack = $cookies.get("crBounceBack");
			if (this.isBounceBack && !cookieBounceBack) {
				Bounceback.init({
					maxDisplay: 1, // not used handle by custom cookie
					distance: 100,
					sensitivity: 10,
					cookieLife: 2, // not used handle by custom cookie
					scrollDelay: 500,
					// checkReferrer: false,
					aggressive: true,
					onBounce: () => {
						let cookieBB = $cookies.get("crBounceBack");
						// cookieBB = false;
						if (!cookieBB) {
							$timeout(() => {
								let popupsOpened = document.querySelectorAll('._has_veil');
								let popupsOpenedCRPopup = document.querySelectorAll('.cr-popup._opened');
								let popupRegistrationOpened = document.querySelectorAll('.cmp-registration-content-wrapper.opened');
								if (popupsOpened.length === 0 && popupsOpenedCRPopup.length === 0 && popupRegistrationOpened.length === 0) {
									this.openPopup();
									let expirationDate = moment().add(2, 'days').format();
									$cookies.put("crBounceBack", true, {path: "/", expires: expirationDate});
								}
							});
						}
					}
				})
			}
		};

		this.resize = () => {
			if (this.isOpened && !this.isNotfsMobile) {
				let popupItem = $element[0].querySelector('.cr-popup-item');
				popupItem.style.height = `${window.innerHeight}px`;
			}
		};

		this.$onDestroy = () => {
			for (const [key, value] of Object.entries(this.callbacks)) {
				document.removeEventListener(`crPopupOpen-${key}`, value);

				let popups = document.querySelectorAll(`cr-popup[data-popup-name="${this.popupName}"]`);
				// check if there is already existing popup outisde of the current element
				popups.forEach(popup => {
					popup.remove();
				});
			}
		};

		this.callbackPopupOpen = (e) => {
			this.openPopup(e);
		};

		this.paginationClicks = 0;
		this.mobileSaleSearchResultsShowPopupInEntry = true;
		this.$postLink = function() {
			var $openPopupLinks = angular.element(document.querySelectorAll('[data-class="cr-popup-open"][data-popup-name="' + ctrl.popupName + '"]'));
			angular.forEach($openPopupLinks, function(btn) {
				ctrl.openOnClick(btn);
			});
			if (ctrl.autoOpen) {
				if (!!ctrl.isMobile) {
					if (ctrl.popupName !== 'popup-in-entry') {
						PubSub.publish('cr-popup-open-' + ctrl.popupName);
					} else {
						PubSub.subscribe('crMPaginationUpdate', (page) => {
							ctrl.paginationClicks++;
							if (ctrl.paginationClicks === 1) {
								this.mobileSaleSearchResultsShowPopupInEntry = false;
								// PubSub.publish('cr-popup-open-' + ctrl.popupName);
							}
						});
					}
				} else {
					PubSub.publish('cr-popup-open-' + ctrl.popupName);
				}
			}
		};

		this.openOnClick = function(btn) {
			let trackCategory = btn.getAttribute("data-track-category");
			let trackAction = btn.getAttribute("data-track-action");
			let trackLabel = btn.getAttribute("data-track-label");

			if (trackCategory && trackAction && trackLabel) {
				crTrackerQueue.track({
					category: trackCategory,
					action: trackAction,
					label: trackLabel
				});
			}

			angular.element(btn).off('click').on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				
				PubSub.publish('cr-popup-open-' + btn.getAttribute('data-popup-name'), btn);
				if (btn.getAttribute('data-fire-event')) {
					PubSub.publish(btn.getAttribute('data-fire-event'));
				}

				let trackClickCategory = btn.getAttribute("data-track-click-category");
				let trackClickAction = btn.getAttribute("data-track-click-action");
				let trackClickLabel = btn.getAttribute("data-track-click-label");

				if (trackClickCategory && trackClickAction && trackClickLabel) {
					crTrackerQueue.track({
						category: trackClickCategory,
						action: trackClickAction,
						label: trackClickLabel
					});
				}				
			});
		};

		this.openPopup = function(optTriggerBtn) {
			var index = optTriggerBtn ? optTriggerBtn.index : null;
			PubSub.publish('cr-popup-update-state-' + ctrl.popupName, {type: 'open', index: index});
			ctrl.hideCloseButton = false;

			if ($element[0].querySelector('.ask-question') && optTriggerBtn && optTriggerBtn.getAttribute('data-mode') === 'ask-question') {
				$element[0].querySelector('.ask-question').click();
			}
			
			if (!ctrl.isMobile) {
				ctrl.disableScroll();
			}

			if (ctrl.isMobile && !ctrl.isNotfsMobile) {
				// $timeout(() => {
					let popupItem = $element[0].querySelector('.cr-popup-item');
					popupItem.style.height = `${window.innerHeight}px`;
				// });
			}

			if(optTriggerBtn) {
				ctrl._trigger = optTriggerBtn;
			}

			ctrl.isOpened = true;
			// just to reset the setting after closing the successMessage popup
			// so the abandonedPopup will work again
			if (ctrl.displayMessageOnClose === false) {
				ctrl.displayMessageOnClose = true;
			}

			// remove  class none
			$timeout(() => {
				let popupContent = $element[0].querySelector('.popup-content-to-show');
				

				if (popupContent) {
					popupContent.classList.remove("none");
				}

				// custom close button
				let buttonClose = $element[0].querySelector('.button-close');
				angular.element(buttonClose).off('click').on('click', (e) => {
					$timeout(() => {
						ctrl.closePopup();
					});
				});

				// this weirdo is for form in popup on article page
				const event = new CustomEvent('popup-is-shown');
				window.dispatchEvent(event);
			});

			if (!ctrl.noFocusOnClose) {
				$timeout(() => {
					ctrl.removeTabbingRestriction = Core.disableTabbingOutside($element[0], ctrl.closePopup)
					const closeBtn = $element[0].querySelector('.close') || $element[0].querySelectorAll('a, input, button')[0];
					if(closeBtn)
						closeBtn.focus();
				}, 200);
			}
		};

		this.disableScroll = function() {
			this.htmlElement.addClass('no-scroll');
		};

		this.enableScroll = function() {
			this.htmlElement.removeClass('no-scroll');
		};

		this.closePopup = function() {
			ctrl.isOpened = false;
			PubSub.publish('cr-popup-update-state-' + ctrl.popupName, {type: 'close'});
			// if (!ctrl.isMobile) {
				ctrl.enableScroll();
			// }

			if (typeof ctrl.removeTabbingRestriction !== 'undefined') {
				ctrl.removeTabbingRestriction();
			}

			let trigger = ctrl._trigger || Core.adaUtility.getTriggerForPopup();
			if(trigger && typeof trigger.focus !== 'undefined') {
				trigger.focus();
				ctrl._trigger = null;
				Core.adaUtility.setTriggerForPopup(null);
			}

			const event = new CustomEvent('popup-is-closed');
			window.dispatchEvent(event);
		};

		this.abandonedPopup = function() {
			PubSub.publish('cr-popup-abandoned-' + this.popupName);
			this.hideCloseButton = true;
		};

		this.continuePopup = function() {
			ctrl.hideCloseButton = false;
		};

		this.successMessagePopup = function() {
			if (ctrl.displayMessageOnClose) {
				ctrl.displayMessageOnClose = false;
			}
		};

		this.scrollTo = function(val) {
			// scrollTop works only with jQuery.
			if (ctrl.isMobile) {
				var $wrapper = angular.element($element[0].querySelector('.cr-popup-wrapper'));
				var offset = $wrapper[0].getBoundingClientRect().top;
				angular.element($element[0].querySelector('.cr-popup')).scrollTop(val - offset);
			}
		};

		this.toggleSuccessMessage = (data) => {
			this.isSuccessMessage = data.isSuccessMessage;
		};

		this.mobileSaleSearchResultsEntryPopupTriggerPoint = null;
		this.mLastListingRenderedToPopupInEntry = (data) => {
			let crMListings = document.querySelectorAll('.cr-m-listing');
			if (!!this.mobileSaleSearchResultsShowPopupInEntry && !!crMListings && !!crMListings.length) {
				this.mobileSaleSearchResultsEntryPopupTriggerPoint = null;
				if (crMListings.length >= 5) {
					this.mobileSaleSearchResultsEntryPopupTriggerPoint = crMListings[4];
				} else {
					this.mobileSaleSearchResultsEntryPopupTriggerPoint = crMListings[crMListings.length - 1];
				}
			}
		};

		PubSub.subscribe('cr-popup-open-' + this.popupName, this.openPopup);
		PubSub.subscribe('cr-popup-close-' + this.popupName, this.closePopup);
		PubSub.subscribe('cr-popup-continue-' + this.popupName, this.continuePopup);
		PubSub.subscribe('cr-popup-success-message-' + this.popupName, this.successMessagePopup);
		PubSub.subscribe('cr-popup-scroll-to-top-' + this.popupName, this.scrollTo);
		PubSub.subscribe('cr-popup-update-success' + this.popupName, this.toggleSuccessMessage);
		PubSub.subscribe('m-last-listing-rendered-to-' + this.popupName, this.mLastListingRenderedToPopupInEntry);
	}]
});